<template>
  <a v-if="title !== '메시지'" id="sns-icon__wraps" @click="shareSns">
    <img :src="image" alt="" />
    <span>{{ title }}</span>
  </a>
  <a v-else id="sns-icon__wraps" :href="smsHref">
    <img :src="image" alt="" />
    <span>{{ title }}</span></a
  >
</template>

<script>
import { mapGetters } from "vuex";
import { makeSmsName } from "../../utils/sms";
export default {
  props: {
    image: {
      type: String,
      default: String
    },
    title: {
      type: String,
      default: String
    },

    device: {
      type: String,
      default: String
    }
  },
  data() {
    return {
      id: this.$route.query.id ? this.$route.query.id : null,
      memberId: this.$route.query.memberId ? this.$route.query.memberId : null
    };
  },
  computed: {
    ...mapGetters(["getObituary"]),

    currentObituaryMember() {
      return (
        this.getObituary?.ObituaryMembers?.length > 0 &&
        this.getObituary?.ObituaryMembers?.filter(
          v => v.id === +this.memberId
        )[0]
      );
    },

    messageRelationTxt() {
      if (!this.currentObituaryMember || !this.memberId) {
        return `故 ${this.getObituary.name}님께서 ${this.getObituary.dieType} 하셨기에 아래와 같이 부고를 전해 드립니다.`;
      }

      return `${makeSmsName(
        this.currentObituaryMember?.memberType,
        this.getObituary?.gender,
        this.currentObituaryMember?.memberName,
        this.getObituary?.name
      )}님께서 ${
        this.getObituary?.dieType
      } 하셨기에 아래와 같이 부고를 전해 드립니다.`;
    },

    smsBody() {
      const encodeId = this.id
        ?.replace(/%20/g, "JR_PLUS")
        .replace(/ /g, "JR_PLUS")
        .replace(/\+/g, "JR_PLUS");
      // .replace(/\=/g, "%3D");

      console.log(encodeId);

      let url = `${process.env.VUE_APP_OBITUARY_BASEURL}/?id=${encodeId}`;

      if (this.$route.query.memberId && !encodeId) {
        url = `${process.env.VUE_APP_OBITUARY_BASEURL}/?memberId=${this.$route.query.memberId}`;
      } else if (this.$route.query.memberId && encodeId) {
        url = `${process.env.VUE_APP_OBITUARY_BASEURL}/?id=${encodeId}&memberId=${this.$route.query.memberId}&bankOnly=${this.$route.query.bankOnly}`;
      }

      // url = url.replace(/&/g, "%2526");
      console.log(url);

      //   const url =
      //     window.location.href
      //       .replace(/%20/g, "JR_PLUS")
      //       .replace(/ /g, "JR_PLUS")
      //       .replace(/\+/g, "JR_PLUS") ||
      //  ;

      const members = [];
      let phoneString = "";
      let memberListString = "";
      let endTxt = "";

      if (
        (this.getObituary.CorpId && this.getObituary.DirectorId) ||
        (this.getObituary.CorpId && !this.getObituary.DirectorId)
      ) {
        endTxt =
          this.getObituary.Corp.name + "에서 제작된 모바일 부고장입니다.";
      } else if (!this.getObituary.CorpId && this.getObituary.DirectorId) {
        endTxt =
          this.getObituary.Director.name +
          " 장례지도사가 제작한 모바일 부고장입니다.";
      } else if (this.getObituary.FuneralId) {
        endTxt =
          this.getObituary.Funeral.name + "에서 제작된 모바일 부고장입니다.";
      }

      if (
        this.getObituary.CorpId &&
        this.getObituary.Corp.name === "장례지도사"
      ) {
        endTxt = "제작된 모바일 부고장입니다";
      }

      const sortMembers = this.getObituary.ObituaryMembers.sort((a, b) => {
        if (a.typeOrder === b.typeOrder) {
          return a.order - b.order;
        }
        return a.typeOrder - b.typeOrder;
      });

      sortMembers.forEach(v => {
        phoneString += `, ${v.memberPhone}`;
        const index = members.findIndex(arg => arg.type === v.memberType);
        if (v.syncFlag) {
          let addName = v.memberName;
          if (v.memberName === "빈빈빈") {
            addName = "      ";
          }
          if (index !== -1) {
            members[index].value += `, ${addName}`;
          } else {
            if (addName) {
              members.push({
                type: v.memberType,
                value: addName
              });
            }
          }
        }
      });
      members.forEach(v => {
        memberListString += `${v.type}: ${v.value} \n`;
      });

      const smsMessage = `${this.messageRelationTxt}

상주정보
${memberListString}

■부고■
${url}


본 메세지는 유가족들의 마음을 담아 ${endTxt}`;

      let realSmsMessage = smsMessage.replace(/(\n|\r\n)/g, "%0a");
      realSmsMessage = smsMessage;

      return encodeURIComponent(realSmsMessage);
    },

    checkMobile() {
      var varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

      if (varUA.indexOf("android") > -1) {
        //안드로이드
        return "android";
      } else if (
        varUA.indexOf("iphone") > -1 ||
        varUA.indexOf("ipad") > -1 ||
        varUA.indexOf("ipod") > -1 ||
        varUA.indexOf("mac") > -1
      ) {
        //IOS
        return "ios";
      } else {
        //아이폰, 안드로이드 외
        return "other";
      }
    },

    smsHref() {
      return (
        "sms:" +
        (this.checkMobile === "ios" ? "&" : "?") +
        "body=" +
        this.smsBody
      );
    }
  },

  methods: {
    shareSns() {
      this.$emit("shareSns");
    }
  }
};
</script>

<style></style>
